<div class="flex min-h-screen justify-center items-center p-4">
  <p-card styleClass="login-card w-full shadow-xl">
    <p-toast position="top-left" />

    <!-- Logo Section -->
    <div class="flex justify-center mb-6">
      <!-- <img [src]="logoUrl" alt="Metabridge Logo" class="h-14 w-auto object-contain" /> -->
      <span class="brand-name"> <span class="brand-meta">META</span><span class="brand-bridge">BRIDGE</span> </span>
    </div>

    <!-- Title Section -->
    <div class="text-center mb-8">
      <h1 class="text-2xl font-semibold m-0 mb-2">{{ loginTitle }}</h1>
      <p *ngIf="showLoginSubtitle" class="text-sm text-gray-600 dark:text-gray-400 m-0">Ingrese sus credenciales</p>
    </div>

    <div class="passkey-enrollment-card" *ngIf="showPasskeyEnrollmentPrompt">
      <div class="passkey-fingerprint-icon" aria-hidden="true">
        <svg class="passkey-fingerprint-svg" viewBox="0 0 96 96" focusable="false" role="img">
          <path d="M48 10c-19.3 0-35 15.7-35 35" />
          <path d="M83 45c0-19.3-15.7-35-35-35" />
          <path d="M25 45c0-12.7 10.3-23 23-23s23 10.3 23 23" />
          <path d="M35 46c0-7.2 5.8-13 13-13s13 5.8 13 13" />
          <path d="M48 45v7c0 17.1-8.8 27.1-20 33" />
          <path d="M59 53c-1.1 14.6-7.8 25.5-18.1 32" />
          <path d="M70 50c0 15.7-5.9 28-16.7 36" />
          <path d="M37 58c-2.3 7.7-7.3 13.8-14 18" />
          <path d="M15 57c1.4 5.9 4.2 10.5 8.2 13.9" />
          <path d="M81 58c-1.5 10.9-5.3 20.3-11.5 28" />
          <path d="M48 45c0 9.5-2 16.5-6.2 22" />
        </svg>
      </div>

      <p>Cree una <strong>"passkey"</strong> para iniciar sesion rapidamente en Metabridge. No mas contraseñas, apps o codigos necesarios.</p>

      <div class="passkey-enrollment-actions">
        <p-button
          label="Registrar"
          icon="pi pi-key"
          iconPos="left"
          severity="primary"
          [loading]="enrollingPasskey"
          (onClick)="enrollPasskeyAfterLogin()"
          styleClass="w-full"
        ></p-button>
        <p-button
          label="Evitar por ahora"
          icon="pi pi-times"
          iconPos="left"
          severity="secondary"
          variant="outlined"
          [disabled]="enrollingPasskey"
          (onClick)="skipPasskeyEnrollment()"
          styleClass="w-full"
        ></p-button>
      </div>
    </div>

    <div class="mb-5 grid gap-3" *ngIf="showPreviousSessionPicker">
      <p-card
        *ngFor="let session of previousSessions; trackBy: trackBySessionKey"
        styleClass="overflow-hidden rounded-2xl border border-surface-200/80 bg-surface-0 shadow-sm transition-all duration-150 hover:-translate-y-0.5 hover:border-primary-300 hover:shadow-md dark:border-surface-700/80 dark:bg-surface-900"
      >
        <div class="flex items-center gap-3">
          <button
            pRipple
            type="button"
            class="flex min-w-0 flex-1 cursor-pointer items-center gap-3 rounded-xl border-0 bg-transparent p-0 text-left text-surface-900 transition-colors duration-150 disabled:cursor-wait disabled:opacity-70 dark:text-surface-0 p-ripple"
            [disabled]="loading"
            (click)="session.hasPasskey ? loginWithPreviousPasskey(session) : selectPreviousSession(session)"
          >
            <p-avatar
              [icon]="session.hasPasskey ? 'pi pi-key' : 'pi pi-user'"
              shape="circle"
              styleClass="!h-11 !w-11 shrink-0 !bg-primary-50 !text-primary-700 dark:!bg-primary-400/10 dark:!text-primary-300"
            ></p-avatar>
            <span class="min-w-0 flex-1">
              <span class="block truncate text-sm font-bold">{{ session.email }}</span>
              <span class="mt-0.5 block truncate text-xs text-surface-500 dark:text-surface-400">
                {{ session.hasPasskey ? 'Continuar con esta sesión' : 'Ingresar contraseña' }}
              </span>
            </span>
          </button>

          <p-button
            icon="pi pi-times"
            severity="danger"
            variant="text"
            size="small"
            pTooltip="Eliminar de este equipo"
            tooltipPosition="top"
            [disabled]="loading"
            (onClick)="removePreviousSession($event, session)"
            [attr.aria-label]="'Eliminar sesión local de ' + session.email"
            title="Eliminar de este equipo"
          ></p-button>
        </div>
      </p-card>

      <p-button
        label="Iniciar sesión con otra cuenta"
        icon="pi pi-envelope"
        iconPos="left"
        severity="secondary"
        variant="outlined"
        [disabled]="loading"
        (onClick)="startPasswordLogin()"
        styleClass="w-full justify-center border-dashed"
      ></p-button>
    </div>

    <!-- Form Section -->
    <form
      *ngIf="showCredentialLogin"
      [formGroup]="loginForm"
      (ngSubmit)="!emailStepConfirmed ? continueWithEmail() : passkeyRequired ? completePasskeyChallenge() : onLogin()"
      class="w-full flex flex-col gap-6"
    >
      <!-- Email Field -->
      <div class="flex flex-col gap-2" *ngIf="!mfaRequired">
        <div class="flex items-center justify-between gap-3">
          <label for="username" class="font-medium">Correo electrónico <span class="text-red-500">*</span></label>
          <p-button
            *ngIf="emailStepConfirmed && !mfaRequired && !passkeyRequired"
            type="button"
            label="Cambiar"
            icon="pi pi-pencil"
            iconPos="left"
            severity="warn"
            variant="text"
            size="small"
            [disabled]="loading"
            (onClick)="changeEmail()"
          ></p-button>
        </div>
        <input
          id="username"
          type="text"
          pInputText
          formControlName="email"
          placeholder="correo@ejemplo.com"
          autocomplete="username"
          class="w-full"
          [readonly]="emailStepConfirmed || passkeyRequired || mfaRequired"
        />
        <small class="text-gray-500" *ngIf="selectedPreviousSessionEmail && !passkeyRequired && !mfaRequired">
          Session previa seleccionada. Ingresa tu contraseña para continuar.
        </small>
      </div>

      <p-button
        *ngIf="!emailStepConfirmed && !passkeyRequired"
        type="button"
        label="Continuar"
        icon="pi pi-arrow-right"
        iconPos="right"
        severity="info"
        [loading]="checkingPasskeyStatus"
        [disabled]="loginForm.get('email')?.invalid"
        (onClick)="continueWithEmail()"
        styleClass="w-full"
      ></p-button>

      <!-- Password Field -->
      <div class="flex flex-col gap-2" *ngIf="emailStepConfirmed && !mfaRequired && !passkeyRequired">
        <div class="flex justify-between items-center">
          <label for="password" class="font-medium">Contraseña <span class="text-red-500">*</span></label>
          <p-button
            type="button"
            label="¿Olvidaste tu contraseña?"
            severity="secondary"
            variant="text"
            size="small"
            (onClick)="openForgetPasswordDialog()"
          ></p-button>
        </div>
        <p-password
          #passwordInput
          id="password"
          formControlName="password"
          [feedback]="false"
          [toggleMask]="true"
          placeholder="Ingresa tu contraseña"
          autocomplete="current-password"
          styleClass="w-full"
          inputStyleClass="w-full"
        ></p-password>
      </div>

      <!-- MFA Field -->
      <div class="flex flex-col items-center gap-4" *ngIf="emailStepConfirmed && mfaRequired">
        <div class="flex flex-col items-center gap-1 text-center">
          <label for="mfaCode" class="font-medium">Ingresa tu código de verificación</label>
          <small class="text-gray-500">
            {{
              mfaMethod === 'SMS_MFA'
                ? 'Escribe el código de 6 dígitos que enviamos por SMS.'
                : 'Escribe el código de 6 dígitos que genera tu app de autenticación.'
            }}
          </small>
        </div>

        <p-inputotp id="mfaCode" formControlName="mfaCode" [length]="6" [integerOnly]="true"></p-inputotp>

        <div class="flex w-full flex-col gap-2">
          <p-button
            type="button"
            label="Iniciar sesión"
            icon="pi pi-sign-in"
            iconPos="left"
            severity="primary"
            [loading]="loading"
            [disabled]="!isMfaCodeComplete"
            (onClick)="onLogin()"
            styleClass="w-full"
          ></p-button>

          <p-button
            type="button"
            label="Cancelar"
            icon="pi pi-times"
            iconPos="left"
            severity="secondary"
            variant="outlined"
            [disabled]="loading"
            (onClick)="cancelMfaChallenge()"
            styleClass="w-full"
          ></p-button>

          <small class="text-center text-xs text-gray-500">¿Es otra cuenta? Cancela para volver a ingresar tu correo.</small>
        </div>
      </div>

      <!-- Passkey Field -->
      <div class="passkey-step" *ngIf="passkeyRequired">
        <div class="passkey-icon"><i class="pi pi-key"></i></div>
        <div>
          <h2>Confirma con tu passkey</h2>
          <p>Ya validamos tu contraseña. Ahora usa Face ID, Touch ID, Windows Hello o tu llave de seguridad para completar el inicio de sesión.</p>
        </div>
        <div class="passkey-actions">
          <p-button
            type="button"
            label="Continuar con passkey"
            icon="pi pi-shield"
            iconPos="left"
            severity="primary"
            [loading]="loading"
            (onClick)="completePasskeyChallenge()"
            styleClass="w-full"
          ></p-button>
          <p-button
            type="button"
            label="Cancelar"
            icon="pi pi-times"
            iconPos="left"
            severity="secondary"
            variant="outlined"
            (onClick)="cancelPasskeyChallenge()"
            styleClass="w-full"
          ></p-button>
        </div>
      </div>

      <!-- Submit Button -->
      <p-button
        *ngIf="emailStepConfirmed && !passkeyRequired && !mfaRequired"
        type="button"
        label="Iniciar sesión"
        icon="pi pi-sign-in"
        iconPos="left"
        severity="primary"
        [loading]="loading"
        [disabled]="loginForm.invalid"
        (onClick)="onLogin()"
        styleClass="w-full"
      ></p-button>

      <div *ngIf="emailStepConfirmed && emailHasPasskey && !passkeyRequired && !mfaRequired" class="grid gap-3">
        <div class="flex items-center gap-3 text-xs text-surface-500 dark:text-surface-400">
          <span class="h-px flex-1 bg-surface-200 dark:bg-surface-700"></span>
          <span>o</span>
          <span class="h-px flex-1 bg-surface-200 dark:bg-surface-700"></span>
        </div>

        <p-button
          type="button"
          label="Iniciar sesión con Passkey"
          icon="pi pi-key"
          iconPos="left"
          severity="secondary"
          variant="outlined"
          [loading]="loading"
          [disabled]="!supportsPasskeys"
          (onClick)="loginWithPasskeyFromForm()"
          styleClass="w-full"
        ></p-button>

        <small class="text-center text-xs text-surface-500 dark:text-surface-400">
          Ingresa tu correo y usa Face ID, Touch ID, Windows Hello o tu llave de seguridad.
        </small>
      </div>
    </form>

    <!-- Footer -->
    <p-divider></p-divider>
    <div class="flex items-center justify-center gap-2 mt-4">
      <span class="text-gray-600 text-xs pt-0.5">Desarrollado por</span>
      <img [src]="innervycsLogoUrl" alt="Innervycs" class="h-5 w-auto object-contain" />
    </div>
  </p-card>
</div>

<!-- Dialogo 'Confirmar Registro'-->
<app-confirm-sign-in
  [showDialog]="this.showConfirmSignUp"
  [userInformation]="this.loginForm.value"
  [sessionToken]="this.nextStepSessionToken"
  (passwordChanged)="this.onLogin(this.loginForm.value.email, $event)"
></app-confirm-sign-in>

<!-- Dialogo 'Olvido su contraseña?'-->
<app-forget-password
  [showDialog]="this.showForgetPassword"
  [userInformation]="this.loginForm.value"
  (passwordChanged)="this.onLogin(this.loginForm.value.email, $event)"
  (onCancel)="closeForgetPasswordDialog()"
></app-forget-password>
